export interface ChangelogEntry {
  version: string;
  date: string;
  type: 'major' | 'minor' | 'patch';
  changes: {
    added?: string[];
    fixed?: string[];
    improved?: string[];
    changed?: string[];
  };
}

export const changelogData: ChangelogEntry[] = [
  {
    version: '2.0.121',
    date: '11/06/2026',
    type: 'patch',
    changes: {
      changed: [
        'Oficina: triagem classifica o serviço sem atribuir responsável; mecânico pode iniciar qualquer OS elegível',
      ],
    },
  },
  {
    version: '2.0.120',
    date: '11/06/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Agendamentos: vaga do horário permanece ocupada após conclusão da OS; só cancelamento libera para novo agendamento',
      ],
    },
  },
  {
    version: '2.0.119',
    date: '11/06/2026',
    type: 'patch',
    changes: {
      added: [
        'Fluxo completo de oficina: mecânico inicia serviço/entrega na recepção e recepção conclui entrega ao cliente',
      ],
      improved: [
        'Notificações de equipe por status de agendamento/OS e push de avaliação com deep link direto para o agendamento',
      ],
    },
  },
  {
    version: '2.0.118',
    date: '11/06/2026',
    type: 'patch',
    changes: {
      improved: [
        'App cliente: confirmação de recebimento da moto obrigatória antes de avaliar o atendimento da oficina',
      ],
    },
  },
  {
    version: '2.0.117',
    date: '11/06/2026',
    type: 'patch',
    changes: {
      added: [
        'Indicadores ZehMotoca: motivos de avaliações Ruim listados abaixo do gráfico',
      ],
      improved: [
        'App cliente: motivo obrigatório ao avaliar atendimento da oficina como Ruim',
      ],
    },
  },
  {
    version: '2.0.116',
    date: '11/06/2026',
    type: 'patch',
    changes: {
      improved: [
        'Logs de importação do ERP: vencimentos extremos e totais por empresa (títulos, clientes e locações)',
      ],
    },
  },
  {
    version: '2.0.115',
    date: '11/06/2026',
    type: 'patch',
    changes: {
      improved: [
        'Importação do ERP: suporte à paginação de get-titulos-receber (varre todas as páginas automaticamente)',
      ],
    },
  },
  {
    version: '2.0.114',
    date: '01/06/2026',
    type: 'patch',
    changes: {
      improved: [
        'Agendamento no app: sábado com horários 8h–9h59 e 10h–11h59',
      ],
    },
  },
  {
    version: '2.0.113',
    date: '01/06/2026',
    type: 'patch',
    changes: {
      improved: [
        'Agendamento de revisão no app: domingos indisponíveis; sábados apenas até 10h (janela 8h–9h59)',
      ],
    },
  },
  {
    version: '2.0.112',
    date: '29/05/2026',
    type: 'patch',
    changes: {
      improved: [
        'Templates de checklist da oficina: empresa editável no modal de criação e edição',
      ],
    },
  },
  {
    version: '2.0.111',
    date: '29/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Configuração ZehMotoca: duplicar template de checklist da oficina (cópia inativa com todos os itens)',
      ],
    },
  },
  {
    version: '2.0.110',
    date: '29/05/2026',
    type: 'patch',
    changes: {
      improved: [
        'Abertura de OS no ERP: queixa relatada inclui no checklist somente itens já marcados (sem pendentes)',
      ],
    },
  },
  {
    version: '2.0.109',
    date: '29/05/2026',
    type: 'patch',
    changes: {
      improved: [
        'Oficina: inspetor altera quilometragem no app; KM da OS mobile reflete no agendamento vinculado',
      ],
    },
  },
  {
    version: '2.0.108',
    date: '29/05/2026',
    type: 'patch',
    changes: {
      improved: [
        'Oficina triagem: classificação do agendamento permitida sem checklist de inspeção totalmente preenchido',
      ],
    },
  },
  {
    version: '2.0.107',
    date: '25/05/2026',
    type: 'patch',
    changes: {
      improved: [
        'Oficina agendamentos: transcrição do relato em áudio salva no cadastro/upload e exibida no detalhe sem retranscrever',
      ],
    },
  },
  {
    version: '2.0.105',
    date: '21/05/2026',
    type: 'patch',
    changes: {
      added: [
        'API oficina: abertura de OS no ERP FlyStart ao toque em "Abrir ordem de serviço" (queixa com agendamento + checklist)',
        'Cadastro staff oficina: CPF para integração ERP',
      ],
      improved: [
        'App inspetor: sincronização ERP com feedback de erro antes de abrir o detalhe da OS',
      ],
    },
  },
  {
    version: '2.0.96',
    date: '20/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Oficina mobile (recepção): dashboard com indicadores pessoais e foto de perfil do staff',
      ],
      improved: [
        'API oficina: métricas da recepção, atribuição de check-in/não compareceu ao recepcionista',
      ],
    },
  },
  {
    version: '2.0.95',
    date: '20/05/2026',
    type: 'patch',
    changes: {
      improved: [
        'Check-in na recepção: revisão do que o cliente informou, observações e km antes de confirmar',
      ],
    },
  },
  {
    version: '2.0.94',
    date: '20/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Oficina mobile: jornada de agendamentos separada por perfil (recepção com placa e não compareceu; inspetor com triagem e checklist)',
      ],
      improved: [
        'API oficina: busca por placa, não compareceu e checklist automático na triagem',
      ],
    },
  },
  {
    version: '2.0.93',
    date: '20/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Jornada da oficina: agendamento de revisão com 4 janelas/dia, triagem e avaliação (app cliente e staff)',
        'Configurações ZehMotoca: aba Agendamento Oficina (vagas, agendamentos, direcionamento, indicadores)',
      ],
    },
  },
  {
    version: '2.0.92',
    date: '19/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Dashboard e estatísticas de kanban não contam título como vencido no dia do vencimento',
      ],
      improved: [
        'Kanban: seleção de títulos vencidos no pagamento respeita status efetivo pela data',
      ],
    },
  },
  {
    version: '2.0.91',
    date: '19/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Títulos não são mais marcados como vencidos no dia do vencimento (fuso Fortaleza; evita falso vencido quando o servidor MySQL está em UTC)',
        'Importação grava vencimento às 23:59:59 do dia',
      ],
      improved: [
        'ZehMotoca — aba Usuários em tabela com ordenação (TanStack Table)',
        'Configuração de e-mail: presets Gmail e teste para destinatário configurável',
        'Kanban exibe status efetivo do título conforme a data de vencimento',
      ],
    },
  },
  {
    version: '2.0.90',
    date: '15/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Templates de checklist oficina: Grupo → Item → ações permitidas (OK, Inspecionar, Ajustar, Trocar, Urgente)',
      ],
      changed: [
        'API e app mobile: novo enum de ação no checklist; snapshot de ações na abertura da OS',
      ],
    },
  },
  {
    version: '2.0.89',
    date: '14/05/2026',
    type: 'patch',
    changes: {
      added: [
        'API Oficina mobile: campos diagnóstico/observações técnicas na OS; histórico de ordens por placa (ERP + app)',
      ],
      changed: [
        'Permissões recepção/inspetor (recepção sem KM/fotos); Web rótulos de perfil; Mobile 1.0.23 triagem e histórico no detalhe da OS',
      ],
    },
  },
  {
    version: '2.0.88',
    date: '14/05/2026',
    type: 'patch',
    changes: {
      added: [
        'API Oficina mobile: perfis RECEPCIONISTA, INSPETOR, MECANICO; status PRE_TRIAGEM; regras de permissão e sincronização ERP só após abertura da OS',
        'Web ZehMotoca: campo Perfil ao cadastrar usuário da equipe oficina',
      ],
      changed: [
        'Mobile ZehMotoca 1.0.22: fluxo recepcionista/inspetor/mecânico, faixa de OS em pré-triagem na aba Ordens e UI de detalhe conforme perfil',
      ],
    },
  },
  {
    version: '2.0.87',
    date: '14/05/2026',
    type: 'patch',
    changes: {
      added: [
        'API Oficina mobile: espelho mobile criado ao abrir detalhe de OS ERP sem registro; POST /ordens/:id/checklist-template para aplicar template em OS sem itens',
      ],
      changed: [
        'Mobile ZehMotoca 1.0.20: tela de detalhe da OS — aplicar checklist vazio (ERP), unwrap da API e debounce de observação nos itens',
      ],
    },
  },
  {
    version: '2.0.86',
    date: '14/05/2026',
    type: 'patch',
    changes: {
      added: [
        'API: CRUD admin `/configuracoes/aplicativo-zehmotoca/checklist-templates-oficina` (templates de checklist por empresa)',
        'Web: aba Checklist Oficina no painel Aplicativo ZehMotoca',
      ],
    },
  },
  {
    version: '2.0.85',
    date: '14/05/2026',
    type: 'patch',
    changes: {
      added: [
        'API: GET /api/v1/mobile/oficina/board — mesmo Kanban do painel web (colunas por setor, OS espelho ERP em execução)',
      ],
      changed: [
        'Mobile ZehMotoca 1.0.17: aba Ordens com Kanban alinhado ao painel da oficina (substitui lista filtrada por chips)',
      ],
    },
  },
  {
    version: '2.0.84',
    date: '14/05/2026',
    type: 'patch',
    changes: {
      added: [
        'API: módulo Oficina OS mobile (staff, OS operacional, rotas /mobile/oficina)',
        'Web: aba Equipe Oficina no painel ZehMotoca',
        'Mobile ZehMotoca 1.0.14: login Acesso Oficina, dashboard/lista OS, checklist e fotos',
      ],
    },
  },
  {
    version: '2.0.83',
    date: '12/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Diretoria: indicador Custo por moto via ERP FlyStart',
        'API: endpoint /reports/diretoria/custo-por-moto com filtro por Company.coderp',
      ],
    },
  },
  {
    version: '2.0.82',
    date: '12/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Diretoria: indicador Motos por status via ERP FlyStart',
        'API: endpoint /reports/diretoria/motos-por-status com filtro por Company.coderp',
      ],
    },
  },
  {
    version: '2.0.81',
    date: '12/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Diretoria: indicador Motos disponíveis via ERP FlyStart por marca',
        'API: endpoint /reports/diretoria/motos-disponiveis com filtro por Company.coderp',
      ],
    },
  },
  {
    version: '2.0.80',
    date: '12/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Diretoria: faturamento do mês e receita projetada via ERP FlyStart nos cards superiores',
        'API: endpoints /reports/diretoria/faturamento-mes e /reports/diretoria/receita-projetada com filtro por Company.coderp',
      ],
      improved: [
        'Diretoria: KPIs de cobrança mantêm dados reais do dashboard quando já carregados',
      ],
    },
  },
  {
    version: '2.0.79',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      changed: [
        'Teste SQL FlyStart (API Externa): visível e permitido só para admin@cobrancas.com (UI + API)',
      ],
    },
  },
  {
    version: '2.0.78',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      fixed: ['FlyStart SQL: path padrão /consultaSqlFlystart (singular consulta)'],
    },
  },
  {
    version: '2.0.77',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'FlyStart consultas SQL: fallback de path em 404; erro legível quando o ERP devolve HTML',
      ],
    },
  },
  {
    version: '2.0.76',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Configurações > API Externa: teste de consulta SQL FlyStart (JSON + tabela); API POST /config/external-api/flystart-sql-test (admin)',
      ],
    },
  },
  {
    version: '2.0.75',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      added: [
        'API: integração FlyStart consultas SQL (env FLYSTART_SQL_API_*), GET /reports/diretoria/erp-snapshot',
        'Diretoria: indicador de conexão ERP em tempo real (snapshot + fallback se ERP indisponível)',
      ],
    },
  },
  {
    version: '2.0.74',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      added: [
        'Modal de cliente: operador ao lado da etapa na seção Onde está (funil kanban)',
      ],
    },
  },
  {
    version: '2.0.73',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Kanban com filtro por operador: mostra títulos do funil do cliente quando o operador já tem outro título ativo desse cliente (ex.: Washington na multa e locação sem operador no Cobranças)',
      ],
      improved: [
        'Cache do board invalidado após ajuste do filtro por operador',
      ],
    },
  },
  {
    version: '2.0.72',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Kanban Cobranças: títulos ABERTOS com vencimento já passado voltam a aparecer no funil (antes só VENCIDO/PARCIAL; Multas já listava ABERTO)',
        'Kanban: card não é mais ignorado quando só há ABERTO vencido no grupo',
        'Distribuição Multas: menos falso positivo por texto genérico “MULTA” em locação',
      ],
      improved: [
        'Cache do board invalidado após ajuste (query do Kanban)',
      ],
    },
  },
  {
    version: '2.0.71',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Kanban: consulta com kanbanId não usa mais limite de 10 mil títulos (skip/take), evitando sumir cards no Cobranças quando há muitos títulos ordenados por vencimento',
      ],
    },
  },
  {
    version: '2.0.70',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Kanban Cobranças: lista do board volta a confiar só em kanbanId + status (remove pós-filtro que podia esconder título de locação quando o cliente também tem multa)',
      ],
    },
  },
  {
    version: '2.0.69',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Kanban Cobranças: filtro pós-query igual à procedure (TRIM em statusLocacao, multa); busca por nome/código do cliente e descrição do título',
      ],
    },
  },
  {
    version: '2.0.68',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Kanban Cobranças: lista da API alinhada à regra de distribuição (status PARCIAL; statusLocacao APROVADA ou vazio); montagem do board escolhe etapa válida no kanban atual',
      ],
    },
  },
  {
    version: '2.0.67',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      improved: [
        'Importação sistema financeiro externo: período máximo de consulta entre data início e fim ampliado para 4 anos (1460 dias); configuração “Período padrão (dias)” limitada ao mesmo teto',
      ],
    },
  },
  {
    version: '2.0.66',
    date: '11/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Kanban: mover card por cliente não sobrescreve mais títulos do mesmo cliente em outro kanban (ex.: Multas + Cobranças); endpoint de lista do kanban tolera kanbanEtapaId inconsistente quando kanbanId está correto',
      ],
    },
  },
  {
    version: '2.0.65',
    date: '09/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'API: CORS — dedupe de Access-Control-Allow-Origin após compression + removeHeader antes de setar ACAO (menos chance de header duplicado na resposta)',
      ],
    },
  },
  {
    version: '2.0.64',
    date: '09/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'API: CORS — header Access-Control-Allow-Origin duplicado (proxy + Express) normalizado para um único valor; login do web entre domínios diferentes deixa de falhar por política do navegador',
      ],
    },
  },
  {
    version: '2.0.63',
    date: '07/05/2026',
    type: 'patch',
    changes: {
      improved: [
        'API: locações canceladas — títulos vinculados vão ao Kanban Jurídico após import de locações, após distribuir processados e ao sync de statusLocacao; procedure SQL e allocateCanceledTitlesToJuridico alinhados',
      ],
    },
  },
  {
    version: '2.0.62',
    date: '07/05/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Vencimento de títulos: data correta no Kanban e demais telas quando o backend envia meia-noite UTC (ex.: 29/04 em vez de 28/04 no Brasil); parseCivilDateString e formatadores alinhados',
      ],
    },
  },
  {
    version: '2.0.61',
    date: '30/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Painel Oficina v2 (/dashboard-oficina/v2): Kanban compacto, sem rolagem automática, sem scroll horizontal entre colunas; menu lateral e permissão de módulo',
        'API: permissão do Painel Oficina aceita o href /dashboard-oficina/v2 em allowedModules',
      ],
    },
  },
  {
    version: '2.0.60',
    date: '30/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Diretoria (/diretoria): card de apoio Rique.Ia com link “Clique aqui” (URL configurável em diretoriaMock)'
      ]
    }
  },
  {
    version: '2.0.59',
    date: '30/04/2026',
    type: 'patch',
    changes: {
      improved: [
        'Diretoria (/diretoria): indicador Infrações (multas) com quantidade e valor em R$ nos KPIs e na tabela do modal'
      ]
    }
  },
  {
    version: '2.0.58',
    date: '30/04/2026',
    type: 'patch',
    changes: {
      improved: [
        'Diretoria (/diretoria): gráficos de faixa e por empresa com valores em R$, rótulos nas barras e eixos compactos; título sem “Aging”; mock e API usam saldo monetário nas faixas'
      ]
    }
  },
  {
    version: '2.0.57',
    date: '30/04/2026',
    type: 'patch',
    changes: {
      improved: [
        'Diretoria (/diretoria): área de conteúdo mais larga (até 1680px) e grelha de indicadores com 5 colunas em ecrãs muito largos'
      ]
    }
  },
  {
    version: '2.0.56',
    date: '30/04/2026',
    type: 'patch',
    changes: {
      changed: [
        'Diretoria (/diretoria): removido badge Demo na faixa executiva; removido card Operadores ativos; badge Cobrança só quando o valor vem do dashboard'
      ]
    }
  },
  {
    version: '2.0.55',
    date: '30/04/2026',
    type: 'patch',
    changes: {
      improved: [
        'Diretoria (/diretoria): cores semânticas nos KPIs (verde = bom, vermelho = risco/atenção) na faixa executiva, cartões e sparklines; tons dinâmicos no merge com dashboard e em Motos por status'
      ]
    }
  },
  {
    version: '2.0.54',
    date: '30/04/2026',
    type: 'patch',
    changes: {
      improved: [
        'Diretoria (/diretoria): faixa de KPIs executivos, visão geral com gráficos (evolução, aging, empresas), integração opcional com dashboard de cobrança; cartões com KPI principal e sparkline; mock de frota por 9 status canônicos; cenário demo por unidade/período'
      ]
    }
  },
  {
    version: '2.0.53',
    date: '29/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'API: teste/envio SMTP do app ZehMotoca com TLS correto por porta (evita erro wrong version number em 587)',
        'Web: dica de SMTP na tela Aplicativo ZehMotoca (587/2525 vs 465)'
      ]
    }
  },
  {
    version: '2.0.52',
    date: '28/04/2026',
    type: 'patch',
    changes: {
      improved: [
        'Portal: cards dos módulos com visual mais quadrado e grade centralizada na tela'
      ]
    }
  },
  {
    version: '2.0.51',
    date: '28/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Distribuição: atribuição de títulos reforçada para usar apenas usuários OPERADOR ativos com permissão na empresa'
      ]
    }
  },
  {
    version: '2.0.50',
    date: '28/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Usuários: novo papel OFICINA disponível no role, com suporte nas validações, tipos e cadastro/edição'
      ]
    }
  },
  {
    version: '2.0.49',
    date: '28/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Importação/API: títulos com statusLocacao CANCELADO passam a ser forçados para o Kanban Jurídico e não permanecem em Cobranças'
      ]
    }
  },
  {
    version: '2.0.48',
    date: '28/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Importação: botão Distribuir títulos usa timeout estendido na requisição para evitar erro de rede em distribuições demoradas'
      ]
    }
  },
  {
    version: '2.0.47',
    date: '27/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Modais: scroll vertical no componente base Modal (Dashboard e outras telas com conteúdo longo)'
      ]
    }
  },
  {
    version: '2.0.46',
    date: '27/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Diretoria (/diretoria): mockup com 10 indicadores, modais de análise (Recharts) e aviso de pré-visualização; entrada pelo portal e menu lateral (Admin/Gestor)'
      ]
    }
  },
  {
    version: '2.0.45',
    date: '22/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Indicação: CORS passa a incluir automaticamente a origem de APP_INDICACAO_BASE_URL (subdomínio dedicado ex. indicacoes.*); doc no .env_exemple'
      ]
    }
  },
  {
    version: '2.0.44',
    date: '22/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Web: painel Oficina — no card do Kanban, linha Técnico a partir de tecnicos_nomes (API)',
        'API/DB: oficina_ordens_servico armazena id_empresa, nome_fantasia, orcamentista, ids_apontamentos e tecnicos; espelho e CSV alinhados'
      ]
    }
  },
  {
    version: '2.0.43',
    date: '20/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Web: na topbar, menu do usuário com opção Alterar senha (modal com validação alinhada à API); após troca, logout e retorno ao login'
      ]
    }
  },
  {
    version: '2.0.42',
    date: '20/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Web/API: dashboard principal e aba Estatísticas por Kanban respeitam empresas vinculadas (user_companies) para OPERADOR e GESTOR; GET /companies liberado para operador com lista filtrada',
        'API: /reports/kanban-stats aplicava papel na query de forma incompleta — agora filtra títulos por empresa e, para operador, por operadorId na SQL',
        'API: dashboard, aging (modal), gráfico e detalhes de operadores alinhados ao mesmo escopo de empresas'
      ]
    }
  },
  {
    version: '2.0.41',
    date: '20/04/2026',
    type: 'patch',
    changes: {
      changed: [
        'Dashboard Oficina: cards do Kanban voltam ao estilo uniforme (sem fundo/borda na cor do veículo); a cor continua exibida no texto da linha Veículo'
      ]
    }
  },
  {
    version: '2.0.40',
    date: '20/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Web: seção premium de Instagram na landing /zehmotoca com filtros Todos/Reels/Publicações, autoplay, setas e indicadores',
        'API: endpoint público /api/v1/mobile/zehmotoca/instagram-feed com integração oEmbed e cache de 5 minutos'
      ]
    }
  },
  {
    version: '2.0.39',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'API: CORS passa a permitir o header X-App-Version (login área do cliente e app mobile em produção com origem diferente da API)'
      ]
    }
  },
  {
    version: '2.0.38',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Web: filtro de busca em usuários e indicações (config Zeh Motoca) não tratava mais string vazia de dígitos como match em CPF/telefone (listagem mostrava todos ao buscar só por nome)'
      ]
    }
  },
  {
    version: '2.0.37',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Web: busca na configuração do app Zeh Motoca (usuários e indicações) passando a considerar lista completa (limite na API) e filtro por código do cliente no campo de usuários',
        'API: listagem de usuários/indicações do app com busca por nome, telefone, e-mail e código do cliente vinculado; limite padrão maior e teto de 5000 registros por requisição'
      ]
    }
  },
  {
    version: '2.0.36',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Web: área do cliente (/cliente/login) com mesma API do app mobile (ClienteFornecedorUser); dashboard, financeiro, FAC, indicações, perfil e notificações; layout e CTAs na landing/rodapé/login SIC'
      ]
    }
  },
  {
    version: '2.0.35',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Web: landing /zehmotoca com carrossel no hero (JP, Natal, Fortaleza), unidades com telefones por canal e endereços; mobile: BannerCarousel com slides das três cidades antes do cartão virtual'
      ]
    }
  },
  {
    version: '2.0.34',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Web: página pública de apresentação Zeh Motoca em /zehmotoca (hero, sobre, diferenciais, planos, FAQ e contato); link no rodapé'
      ]
    }
  },
  {
    version: '2.0.33',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      added: [
        'API mobile: dashboard com objeto cartaoLocacao (locação / contrato) para o cartão virtual no app ZehMotoca'
      ]
    }
  },
  {
    version: '2.0.32',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'API: data de vencimento em notificações, push, e-mail (título vencido) e mensagens WhatsApp de cobrança exibida corretamente (sem “um dia antes” por fuso horário)'
      ]
    }
  },
  {
    version: '2.0.31',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      fixed: [
        'Oficina: Kanban sem colunas duplicadas para o mesmo estágio (merge de setores equivalentes do ERP, ex. SERVICO RAPIDO + Serviços Rápidos); indicadores por setor alinhados ao mesmo rótulo'
      ]
    }
  },
  {
    version: '2.0.30',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      changed: [
        'Dashboard Oficina: cards do Kanban com fundo e borda na cor da moto (campo cor do veículo da OS; hex ou nome)'
      ]
    }
  },
  {
    version: '2.0.29',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      changed: [
        'Dashboard Oficina: total de OS ao lado do título "Clientes em Atendimento" (antes no canto superior direito)'
      ]
    }
  },
  {
    version: '2.0.28',
    date: '19/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Importação (/importacao): clique no bloco "Última sincronização (API)" da Oficina para abrir modal com log detalhado (lista de avisos e resumo do período)'
      ]
    }
  },
  {
    version: '2.0.27',
    date: '16/04/2026',
    type: 'patch',
    changes: {
      changed: [
        'Dashboard Oficina: sem pulso nos cards atrasados; scroll vertical automático das colunas 2× mais rápido'
      ]
    }
  },
  {
    version: '2.0.26',
    date: '16/04/2026',
    type: 'patch',
    changes: {
      changed: [
        'Oficina: OS sem setor cadastrado aparecem na coluna Recepção (Kanban, métricas por setor; import CSV/API gravam Recepção quando setor vazio)'
      ]
    }
  },
  {
    version: '2.0.25',
    date: '16/04/2026',
    type: 'patch',
    changes: {
      changed: [
        'Dashboard Oficina: ordem fixa das colunas do Kanban (Recepção → Serviços Rápidos → Serv. Intermediario → Revisão → Reparo Tecnico); outros setores ao final'
      ]
    }
  },
  {
    version: '2.0.24',
    date: '16/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Dashboard Oficina (/dashboard-oficina): total geral de OS no canto superior direito; total por coluna do Kanban com badge e rótulo "OS neste status"'
      ]
    }
  },
  {
    version: '2.0.23',
    date: '16/04/2026',
    type: 'patch',
    changes: {
      changed: [
        'Integração Oficina (getLocacaoOrdensServicos): headers token e cnpj iguais ao get-locacoes-cliente (mesmo token da config)',
        'Importação (/importacao): card Oficina (API) menciona o mesmo token de títulos e get-locacoes-cliente'
      ]
    }
  },
  {
    version: '2.0.22',
    date: '16/04/2026',
    type: 'patch',
    changes: {
      changed: [
        'Integração Oficina (getLocacaoOrdensServicos): webhook FlyStart por padrão (/webhook/getLocacaoOrdensServicos), parâmetros na query (CNPJ + datas); período inicial 2025-01-01',
        'Importação (/importacao): texto do período da sync Oficina (API) atualizado para 01/01/2025'
      ]
    }
  },
  {
    version: '2.0.21',
    date: '13/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Kanban Oficina: primeira etapa fixa "Recepção" à esquerda; coluna vazia quando não há OS nesse setor; agrupa setor com mesmo nome (pt-BR, ignorando acento/capitalização)'
      ]
    }
  },
  {
    version: '2.0.20',
    date: '13/04/2026',
    type: 'patch',
    changes: {
      added: [
        'Dashboard Oficina (/dashboard-oficina): layout sem modo lista; nome do cliente em destaque; placa Mercosul em duas linhas à direita; relógio centralizado e maior na barra superior',
        'Integração Oficina via API ERP (getLocacaoOrdensServicos): sync manual na importação e job a cada 5 min quando a API externa está habilitada',
        'POST /oficina/sync-api (gestor/admin): recarrega espelho oficina_ordens_servico (truncate + createMany em lotes)',
        'Importação (/importacao): card único "API e CSV" — sync API + upload CSV de Oficina com contadores de resultado',
        'Variável opcional EXTERNAL_API_OFICINA_ORDENS_PATH para customizar o path do endpoint de ordens de serviço',
        'Script apps/api: npm run test:oficina-ordens-api para validar o GET contra o ERP'
      ],
      changed: [
        'Painel Oficina: removida faixa visual tipo "moto"; ajustes de tipografia e alinhamento da placa'
      ],
      improved: [
        'Documentação no próprio card de importação: API substitui o espelho inteiro; CSV faz upsert por empresa + OS'
      ]
    }
  },
  {
    version: '2.0.19',
    date: '15/03/2026',
    type: 'patch',
    changes: {
      added: [
        'Aba "Log de Emails" em /configuracoes/aplicativo-zehmotoca: histórico de envios de email do app mobile (recuperação de senha e primeiro acesso)',
        'Tabela email_send_logs_mobile: registro de cada tentativa de envio com tipo, status (enviado/erro) e mensagem de erro',
        'API GET /configuracoes/aplicativo-zehmotoca/log-emails com filtros (tipo, status, dataInicio, dataFim) e paginação',
        'Persistência automática do log no NotificationService ao enviar código de recuperação ou primeiro acesso'
      ],
      improved: [
        'Recuperação de senha no app mobile: CPF validado por cliente_fornecedor_users.cpfcnpj e email por cliente_fornecedor_users.email',
        'Recuperação de senha apenas por email; opção SMS removida da tela "Recuperar Senha"'
      ],
      changed: [
        'Fluxo de recuperação de senha (mobile) usa exclusivamente tabela cliente_fornecedor_users para buscar usuário e validar email'
      ]
    }
  },
  {
    version: '2.0.18',
    date: '09/03/2026',
    type: 'patch',
    changes: {
      added: [
        'Página de Política de Privacidade no sistema web (/politica-de-privacidade), acessível sem login, com seções: dados coletados, finalidade, base legal, compartilhamento, direitos (LGPD), permissões do app Android (CAMERA, galeria, localização, push)',
        'Link para Política de Privacidade no login e no rodapé do sistema',
        'Aba "Módulos" no cadastro de usuários: seleção de módulos do sistema que o usuário pode acessar (allowedModules)',
        'Filtro da sidebar por allowedModules: quando definido, o menu exibe apenas os módulos permitidos ao usuário',
        'Campo allowedModules no modelo User (API e Prisma) e nas telas de criação/edição de usuário',
        'Campo de busca por nome ou código na listagem de clientes da página de envio de push (filtro em tempo real)',
        'Opção "Enviar para todos os usuários do app" no envio de push (para avisos de nova versão, ex.: template "Nova versão do app")',
        'Endpoint administrativo POST /push-notifications/release-version: atualiza versão mínima do app e opcionalmente envia push "Nova versão" para todos',
        'Tabela app_mobile_version_config: configuração de minVersion e URLs das lojas (iOS/Android); API usa antes das variáveis de ambiente',
        'Template de push "Nova versão do app" no seed e fluxo documentado para lançamento de versões nas lojas',
        'Checklist de submissão às lojas (CHECKLIST_LOJAS.md) no app mobile: requisitos Apple/Google, política de privacidade, conta de teste, App Privacy / Data Safety'
      ],
      fixed: [
        'URL da API em produção no app mobile: removido return antecipado em env.ts; em release passa a usar extra.apiUrl injetado pelo EAS',
        'Mensagem de erro de conexão no mobile em produção: deixa de citar localhost; exibe "Verifique sua internet"',
        'Console.log em produção: interceptors da API e telas do mobile restritos a __DEV__'
      ],
      improved: [
        'Política de privacidade descreve explicitamente android.permission.CAMERA e demais permissões do app',
        'Filtro de clientes no envio de push: contador e "Selecionar todos os filtrados" consideram apenas a lista filtrada pela busca',
        'Build da API: prisma generate executado antes do tsc; script db:push removido do package.json para evitar risco de perda de dados',
        'App mobile: tema fixo em claro (modo escuro removido); userInterfaceStyle light no app.config',
        'App mobile: opção de tirar foto com câmera ou escolher da galeria para foto de perfil; permissão de câmera solicitada apenas ao usar "Tirar foto"'
      ],
      changed: [
        'Sidebar do sistema web: prioridade para allowedModules quando o usuário tiver módulos definidos; caso contrário mantém filtro por role',
        'Módulo Novidades do app mobile oculto na navegação (previsto para versão futura)'
      ]
    }
  },
  {
    version: '2.0.17',
    date: '23/01/2026',
    type: 'patch',
    changes: {
      added: [
        'Sistema de Log de Acesso com Geolocalização para aplicativo mobile',
        'Sistema de Indicação de Amigos para clientes mobile',
        'Sistema de Email para Mobile com templates e configurações',
        'Autenticação Biométrica (Face ID/Touch ID) no aplicativo mobile',
        'Recuperação de Senha Completa com validação de CPF/CNPJ e código de verificação',
        'Filtros Avançados no mobile: período, valor, ordenação múltipla',
        'Busca Melhorada com debounce, múltiplos campos e histórico de buscas',
        'Notificações Locais com agendamento de lembretes de vencimento',
        'Modo Offline Básico com cache de dados e sincronização automática',
        'Compartilhamento de detalhes de título/multa no aplicativo mobile',
        'Feedback Visual (Haptic feedback) em ações importantes',
        'Suporte ao novo formato da API externa do ERP com campos separados'
      ],
      fixed: [
        'Corrigidos 80 erros de compilação TypeScript',
        'Regenerado Prisma Client para incluir todos os modelos mobile',
        'Corrigido import do SendGrid tornando-o opcional',
        'Corrigida redeclaração de variável clienteNome no mapeamento',
        'Corrigido problema de cor de texto na tela de verificação mobile',
        'Melhorado fluxo de verificação de CPF/CNPJ',
        'Corrigido problema com TARGET_OS_SIMULATOR em builds iOS',
        'Melhorado tratamento de erros de rede no mobile'
      ],
      improved: [
        'Mapeamento de dados aprimorado com priorização de novos campos e fallback para formato antigo',
        'Montagem automática de URL do boleto a partir de url_base_boleto + id_impressao_boleto',
        'Montagem automática de telefone a partir de telefone_ddd + telefone_numero',
        'Campos numéricos agora podem vir como string ou number (maior flexibilidade)',
        'SendGrid agora é opcional (não quebra se não estiver instalado)',
        'Mensagens de erro mais claras quando SendGrid não está disponível',
        'Performance melhorada no mobile com FlashList e memoização',
        'Cache inteligente de dados com TTL de 5 minutos',
        'Estrutura de navegação aprimorada no aplicativo mobile',
        'Melhorias na tela de Atendimentos com exibição de placa de locação ativa'
      ],
      changed: [
        'Atualização do formato da API externa: novos campos separados (cliente_nome, cliente_razaosocial, vendedor_nome, etc)',
        'Compatibilidade mantida com formato antigo da API (fallbacks implementados)',
        'Dependências do mobile atualizadas e configurações de EAS aprimoradas'
      ]
    }
  },
  {
    version: '2.0.16',
    date: '16/12/2025',
    type: 'patch',
    changes: {
      added: [
        'Seção "Clientes Distintos por Status" no card de cada kanban na aba "Estatísticas por Kanban" do dashboard',
        'Contagem de clientes distintos por status (Abertos, Vencidos, Parciais, Fechados, Cancelados)',
        'Total de clientes distintos por kanban exibido no card de estatísticas',
        'Visualização comparativa entre quantidade de títulos e quantidade de clientes por status',
        'Quantidade de clientes distintos por etapa do kanban exibida na seção "Etapas"',
        'Informação de clientes distintos em cada etapa do kanban para melhor análise de distribuição'
      ],
      improved: [
        'Melhor análise de distribuição de clientes por status em cada kanban',
        'Interface mais informativa para gestores visualizarem a concentração de clientes por status',
        'Cards de estatísticas por kanban agora mostram tanto quantidade de títulos quanto de clientes',
        'Seção de etapas agora exibe quantidade de clientes distintos além de títulos e valores'
      ]
    }
  },
  {
    version: '2.0.15',
    date: '16/12/2025',
    type: 'patch',
    changes: {
      fixed: [
        'Corrigida distribuição de operadores: agora distribui para TODOS os kanbans (Cobranças, Multas, Jurídico, Congelado)',
        'Títulos em kanbans diferentes de Cobranças agora recebem operadores automaticamente',
        'Removida limitação que impedia distribuição de operadores em kanbans Multas, Jurídico e Congelado'
      ],
      improved: [
        'Distribuição de operadores agora processa todos os kanbans ativos sequencialmente',
        'Melhor balanceamento de carga entre operadores considerando todos os kanbans',
        'Round-robin inteligente: distribuição agora considera carga atual dos operadores (títulos ativos)',
        'Operadores são ordenados por carga antes da distribuição (menos carregado primeiro)',
        'Carga dos operadores é atualizada dinamicamente durante a distribuição para manter balanceamento',
        'Logs mais detalhados mostrando distribuição por kanban e carga dos operadores',
        'Distribuição respeita permissões de empresa: apenas operadores com acesso à empresa recebem títulos'
      ],
      changed: [
        'Lógica de distribuição refatorada para processar todos os kanbans, não apenas Cobranças',
        'Round-robin melhorado: calcula carga atual de cada operador antes de distribuir',
        'Removido card de Estatísticas da página de importação conforme solicitado'
      ]
    }
  },
  {
    version: '2.0.14',
    date: '16/12/2025',
    type: 'patch',
    changes: {
      added: [
        'Modal de logs na página de importação para visualizar detalhes da distribuição de títulos',
        'Coleta automática de logs durante o processo de distribuição de títulos',
        'Botão "Ver Logs da Distribuição" no card de distribuição após execução',
        'Funcionalidade de copiar logs para área de transferência no modal',
        'Logs coloridos por nível (INFO, WARN, ERROR) no modal'
      ],
      improved: [
        'Melhor rastreabilidade do processo de distribuição com logs detalhados',
        'Facilita debug e troubleshooting da distribuição de títulos',
        'Interface mais informativa para acompanhar o processo de distribuição'
      ]
    }
  },
  {
    version: '2.0.13',
    date: '07/12/2025',
    type: 'patch',
    changes: {
      improved: [
        'Tabela titulos_atualizacao agora serve como auditoria: dados permanecem após processamento para rastreabilidade e análise',
        'Removido TRUNCATE após processamento: facilita debug, troubleshooting e análise histórica de importações',
        'Lógica de atualização de status agora considera a data de vencimento, não apenas o status recebido da API externa',
        'Títulos PARCIAL mantêm o status mesmo se vencidos (não mudam para VENCIDO)'
      ],
      fixed: [
        'Corrigido formato do campo numero na tabela titulos: agora usa formato contaid_nomeEmpresa (ex: 101644_ZEH MOTOCA NATAL) mantendo espaços no nome',
        'Corrigido campo codtituloerp: agora é atualizado corretamente com o contaid durante a importação (tanto em títulos novos quanto existentes)',
        'Corrigido status de títulos vencidos: títulos com status ABERTO que já venceram são automaticamente atualizados para VENCIDO durante a importação',
        'Adicionada verificação de data de vencimento na procedure processar_titulos_atualizacao',
        'Criado script SQL para corrigir títulos existentes com status incorreto (corrigir-status-titulos-vencidos.sql)'
      ]
    }
  },
  {
    version: '2.0.12',
    date: '07/12/2025',
    type: 'patch',
    changes: {
      added: [
        'Atualização de títulos via aplicação (sem dependência do arquivo R)',
        'Novo endpoint POST /api/v1/import/external-via-temp-table para atualização via API',
        'Método processExternalTitulosViaTempTable() que replica lógica do arquivo R',
        'Processamento em lote para melhor performance na atualização de títulos',
        'Execução automática das procedures SQL (processar_titulos_atualizacao e distribuir_titulos_processados_v2)',
        'Distribuição automática de operadores após sincronização de títulos (não é mais necessário clicar no botão "Distribuir Títulos")'
      ],
      fixed: [
        'Corrigidos erros de TypeScript no método corrigirOperadoresPorCliente',
        'Adicionadas validações para evitar erros de undefined em operadorMaisFrequente',
        'Corrigida verificação de companyId antes de usar em queries Prisma',
        'Corrigido método getTitulosReceber para usar GET com headers customizados (token e cnpj)',
        'Corrigido formato de autenticação: headers token e cnpj ao invés de Authorization Bearer',
        'Corrigido método de teste de conexão para usar parâmetros diretamente (sem depender de env em cache)',
        'Melhorado tratamento de erros com mensagens mais detalhadas da API externa'
      ],
      improved: [
        'Eliminada dependência do arquivo R para atualização de títulos',
        'Processamento mais rápido com inserção em lote na tabela temporária',
        'Melhor integração com sistema de jobs automáticos via Configurações > API Externa',
        'Logs e tratamento de erros aprimorados na atualização de títulos',
        'Fluxo completo automatizado: importação → processamento → distribuição aos kanbans → distribuição aos operadores'
      ],
      changed: [
        'Atualização de títulos agora pode ser feita 100% via aplicação Node.js',
        'Método de atualização usa tabela temporária titulos_atualizacao seguido de procedures SQL',
        'Período padrão de consulta alterado: data inicial fixa 01/06/2025, data final: hoje + 60 dias',
        'Sistema sempre solicita e exibe campos de data inicial e final na interface',
        'Suporte a múltiplos CNPJs na consulta à API externa (tenta todos e agrega resultados)',
        'Adicionados campos de data inicial e final na tela de Configuração da API Externa',
        'Sincronização automática agora usa as datas configuradas quando disponíveis'
      ]
    }
  },
  {
    version: '2.0.11',
    date: '02/11/2025',
    type: 'patch',
    changes: {
      added: [
        'Módulo Jurídico: Kanban específico para gestão de títulos cancelados',
        'Alocação automática de títulos cancelados ao Kanban Jurídico',
        'Distribuição automática de títulos cancelados entre operadores com acesso ao Kanban Jurídico',
        'Método allocateCanceledTitlesToJuridico para gerenciar títulos cancelados',
        'Suporte especial para Kanban Jurídico na listagem e filtragem de títulos'
      ],
      fixed: [
        'Corrigidos 17 erros de TypeScript que impediam a compilação do projeto',
        'Adicionado import do logger em clienteFornecedorService',
        'Corrigidos parâmetros não utilizados em importController',
        'Corrigida assinatura do método getImportLogs para aceitar parâmetros individuais',
        'Corrigidos erros de tipos undefined em importService',
        'Corrigido uso de TituloStatus.PAGO para TituloStatus.FECHADO',
        'Adicionado método processExternalTitulos ao ImportService',
        'Corrigido uso de prisma.kanban e prisma.userKanban com fallback para query raw'
      ],
      improved: [
        'Reposicionado badge de status da locação para ficar abaixo do nome do operador nos cards do Kanban',
        'Melhorada organização visual dos cards do Kanban',
        'Adicionado tratamento de erros com fallback para query raw quando Prisma Client não está atualizado',
        'Sistema de distribuição inteligente de títulos cancelados baseado na carga de trabalho dos operadores'
      ],
      changed: [
        'Layout dos cards do Kanban: badge de status agora aparece após informações do operador',
        'Títulos com statusLocacao "CANCELADO" são automaticamente direcionados ao Kanban Jurídico durante importação'
      ]
    }
  },
  {
    version: '2.0.0',
    date: '17/09/2025',
    type: 'major',
    changes: {
      added: [
        'Sistema de KPIs para análise de produtividade dos operadores',
        'Modal de changelog com histórico de versões',
        'Filtros de empresa e atrasos para operadores no Kanban',
        'Sistema de versionamento na barra lateral'
      ],
      fixed: [
        'Inconsistência entre Dashboard e Kanban na contagem de clientes',
        'Problema de "Empresa não identificada" no modal de aging',
        'Redirecionamento incorreto ao visualizar arquivos anexos',
        'Filtros não exibidos para usuários operador no Kanban',
        'Problemas de WebSocket e CORS em produção',
        'Discrepância entre modal e dashboard nos dados de aging'
      ],
      improved: [
        'Lógica de agrupamento de títulos por cliente no Kanban',
        'Performance do modal de aging com nova estrutura de dados',
        'Configuração de CORS para melhor compatibilidade',
        'Sistema de reconexão automática do WebSocket',
        'Estrutura de dados do modal de clientes'
      ],
      changed: [
        'Alinhamento da lógica do Dashboard com o Kanban',
        'Refatoração completa do sistema de aging de clientes',
        'Melhoria na exibição de filtros baseada no tipo de usuário'
      ]
    }
  },
  {
    version: '1.9.0',
    date: '15/09/2025',
    type: 'minor',
    changes: {
      added: [
        'Sistema de notificações em tempo real',
        'Chat interno entre operadores e gestores',
        'Upload de comprovantes de pagamento',
        'Gravação de áudio para feedback'
      ],
      fixed: [
        'Problemas de sincronização de dados',
        'Erros de validação em formulários',
        'Bugs na exibição de títulos vencidos'
      ],
      improved: [
        'Interface do Kanban',
        'Performance de consultas ao banco',
        'Sistema de upload de arquivos'
      ]
    }
  },
  {
    version: '1.8.0',
    date: '10/09/2025',
    type: 'minor',
    changes: {
      added: [
        'Dashboard com estatísticas em tempo real',
        'Sistema de relatórios avançados',
        'Filtros por empresa e operador',
        'Exportação de dados em CSV'
      ],
      fixed: [
        'Problemas de carregamento lento',
        'Erros na importação de títulos',
        'Bugs na exibição de datas'
      ],
      improved: [
        'Interface responsiva',
        'Sistema de autenticação',
        'Validação de dados'
      ]
    }
  }
];

export const getChangelogByVersion = (version: string): ChangelogEntry | undefined => {
  return changelogData.find(entry => entry.version === version);
};

export const getLatestChangelog = (): ChangelogEntry => {
  return changelogData[0];
};
